import { useEffect, useRef } from 'react';
import * as queryStriing from 'querystring';
import { Browser } from '../../../const/env';
const marketUrl = 'https://c.union.ucweb.com/index.php?service=RedirectService&offer_id=com.UCMobile.intl&pub=yingna@likee0904';

export function getIntentUrl(oriUrl: string, extraParams: { [key: string]: any }) {
  let params = {};
  if (oriUrl.indexOf('?') !== -1) {
    const urlPrefix = oriUrl.split('?')[0];
    const paramStr = oriUrl.split('?')[1];
    params = queryStriing.parse(paramStr);
    params = Object.assign({}, params, extraParams);
    oriUrl = urlPrefix + '?' + queryStriing.stringify(params);
  }
  const url = 'intent://data?ref=' + encodeURIComponent(oriUrl) + '#Intent;scheme=ucdownload;package=com.UCMobile.intl;end';
  console.log('===> url', url);
  return url;
}

export function tryIframeApproach(iframeUrl: string, downloadUrl?: string) {
  return setTimeout(() => {
    const iframe = document.createElement('iframe');
    iframe.style.border = 'none';
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    if (downloadUrl) {
      iframe.onload = () => {
        document.location.href = downloadUrl;
      };
    }
    iframe.src = iframeUrl;
    document.body.appendChild(iframe);
  }, 1500);
}

export function tryLocationApproach(locationUrl: string, downloadUrl?: string) {
  document.location.href = locationUrl;
  return setTimeout(() => {
    if (downloadUrl) {
      document.location.href = downloadUrl;
    }
  }, 2500);
}

export default () => {
  if (!process.env.BROWSER) {
    return null;
  }
  if (window._ENVI_INFO.browser !== Browser.not_uc_client) {
    return null;
  }
  const buttonRef = useRef(null);

  useEffect(() => {
    const url = getIntentUrl(window.location.href, {
      entry1: 'deeplink',
    });
    let locationTimer;
    let iframeTimer;
    const heartbeat = setInterval(() => {
      if ((document as any).webkitHidden || document.hidden) {
        clearTimers();
      }
    }, 200);

    function clearTimers() {
         clearTimeout(locationTimer);
         clearTimeout(iframeTimer);
         clearTimeout(heartbeat);
    }

    function onDeeplink() {
      iframeTimer = tryIframeApproach(url, null);
    }

    function onClick() {
      if (navigator.userAgent.match(/Chrome/)) {
        locationTimer = tryLocationApproach(url, marketUrl);
      } else if (navigator.userAgent.match(/Firefox/)) {
        locationTimer = tryLocationApproach(url, marketUrl);
        iframeTimer = tryIframeApproach(url, marketUrl);
      } else {
        iframeTimer = tryIframeApproach(url, marketUrl);
      }
    }
    const el: HTMLElement = buttonRef.current;
    if (el) {
      el.addEventListener('click', onClick);
      onDeeplink();
    }
    return () => {
      if (el) {
        el.removeEventListener('click', onClick);
      }
      clearTimers();
    };
  });

  return {
    buttonRef,
  };
};
